 <template>
  <v-container fluid class="pa-5">
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackState"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <v-data-table
      :headers="headers"
      :items="cabinas"
      :search="search"
      :loading="loader"
      loading-text="Buscando asistencias..."
      class="elevation-2"
    >
      <template v-slot:top>
        <v-toolbar flat color="white" class="pt-1">
          <v-toolbar-title>Histórico de Asistencias ASSA</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-col cols="auto" md="3">
            <v-text-field
              class="text-xs-center ml-5"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
          </v-col>

          <v-spacer></v-spacer>

          <v-col cols="auto" md="2">
            <v-text-field
              v-model="fechaInicio"
              type="date"
              hide-details
              label="Desde fecha de creación"
              :max="new Date().toISOString().substr(0, 10)"
              clearable
            >
            </v-text-field>
          </v-col>
          <v-col cols="auto" md="2">
            <v-text-field
              v-model="fechaFin"
              type="date"
              hide-details
              label="Hasta fecha de creación"
              :max="new Date().toISOString().substr(0, 10)"
              clearable
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="1">
            <v-btn @click="listar" color="primary" dark> Listar </v-btn>
          </v-col>
        </v-toolbar>
      </template>
      <template v-slot:[`item.fecha`]="{ item }">
        <span>{{ formatoFecha(item.fecha) }}</span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip top color="#6b705c" dark v-if="true">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="primary"
              @click="oneDrive(item)"
              v-bind="attrs"
              v-on="on"
            >
              fas fa-cloud
            </v-icon>
          </template>
          <span>Ver archivos</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-container>
</template> 


<script>
import moment from "moment";
import axios from "axios";
export default {
  data() {
    return {
      headers: [
        { text: "N° Asistencia", value: "numeroAsistencia" },
        { text: "Tipo Asistencia", value: "tipoAsistencia" },
        { text: "Fecha/Hora", value: "fecha" },
        { text: "Placa", value: "placa" },
        { text: "Cartera", value: "cartera" },
        { text: "Acciones", value: "action", sortable: false },
      ],
      cabinas: [],
      loader: false,
      search: "",
      fechaInicio: this.formatoFechaSearch(new Date()),
      fechaFin: this.formatoFechaSearch(new Date()),
      snackState: false,
      snackColor: "primary",
      snackTime: 5500,
      snackText: "example",
    };
  },
  created() {
    this.listar();
  },
  methods: {
    listar() {
      if (!this.fechaInicio || !this.fechaFin) return;

      let end = moment(this.fechaFin);
      let start = moment(this.fechaInicio);

      let diff = end.diff(start, "months");

      if (diff <= 6) {
        this.loader = true;
        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };

        axios
          .get(
            `/api/corredores?inicio=${this.fechaInicio}&fin=${this.fechaFin}`,
            configuracion
          )
          .then((res) => {
            this.cabinas = res.data;
          })
          .catch((err) => console.log(err))
          .finally(() => {
            this.loader = false;
          });
      } else {
        this.snackColor = "error";
        this.snackText =
          "La diferencia entre fechas no puede ser mayor a 6 meses.";
        this.snackState = true;
      }
    },
    oneDrive(item) {
      // var url = "http://localhost:8080/adminArchivos/";
      var url = "https://asistenciaregional.com/adminArchivos/";
      window.open(url + item.numeroAsistencia, "_blank");
    },
    formatoFecha(fecha) {
      return moment(fecha).format("YYYY-MM-DD HH:mm:ss");
    },
    formatoFechaSearch(fecha) {
      return moment(fecha).format("YYYY-MM-DD");
    },
  },
};
</script>